app.controller("StudentNewSelectionController", [
    "$scope", "Socket", "Students", "StSubject", "$uibModal", "AuthService", "ProgramService", "StaticData", "$q",
    function ($scope, Socket, Students, StSubject, $uibModal, AuthService, ProgramService, StaticData, $q) {
        $scope.subjectStates = {
            blocked: 1,
            normal: 2,
            important: 3,
            critical: 4
        };
        $scope.Math = window.Math;
        $scope.student = {};
        $scope.allCredits = 0;
        $scope.totalItems = 0;
        $scope.semester = 'სემესტრი';
        $scope.studentSemester = null;
        $scope.subNameOrCode = null;
        $scope.filtered = [];
        $scope.selectionCollapse = {};
        $scope.saveDisabled = true;
        $scope.socket = new Socket();

        $scope.socket.on('subject:select', function (sessionGroup) {
            if (!$scope.filtered) return;
            _.each($scope.filtered, function (subject) {
                if (subject.sessionGroups.lectures.length) {
                    var group = _.find(subject.sessionGroups.lectures, {_id: sessionGroup});
                    if (group) {
                        group.selectedCount += 1;
                        return false;
                    }
                }

                if (subject.sessionGroups.seminars.length) {
                    var group = _.find(subject.sessionGroups.seminars, {_id: sessionGroup});
                    if (group) {
                        group.selectedCount += 1;
                        return false;
                    }
                }
            });
        });

        $scope.subjectStates1 = [{studentState: 'passed', name: 'ჩაბარებული'}, {
            studentState: 'failed',
            name: 'ჩაჭრილი'
        },
            {studentState: 'current', name: 'მიმდინარე'}];
        $scope.subjectStates2 = [{studentState: 'blocked', name: 'დაბლოკილი'}, {
            studentState: 'critical',
            name: 'კრიტიკული'
        },
            {studentState: 'important', name: 'მნიშვნელოვანი'}, {studentState: 'normal ', name: 'ზოგადი'}];

        StaticData.getItemsByKey("days").then(function (days) {
            $scope.days = days;
            $scope.daysMap = _.keyBy($scope.days, '_id');
        });

        StaticData.getItemsByKey("buildings").then(function (buildings) {
            $scope.buildings = [{name: "კორპუსი"}].concat(buildings);
            $scope.buildingsMap = _.keyBy($scope.buildings, '_id');
        });

        StaticData.getItemsByKey("container_types").then(function (data) {
            $scope.containerTypes = data;
            $scope.subjectTypes = [{name: "ტიპი"}].concat(data);
            $scope.containerTypesMap = _.keyBy($scope.containerTypes, '_id');
        });

        $scope.$watch('subNameOrCode', function (val) {
            filterSubjects();
        }, true);

        $scope.$watch('semester', function (val) {
            filterSubjects();
        }, true);

        $scope.$watch('subjectType', function (val) {
            filterSubjects();
        }, true);

        AuthService.getProfiles().then(function (profiles) {
            $scope.student = _.find(profiles, {type: 'student', state: 'active'});
            // TODO სტუდენტს შეუძლება არ ჰქონდეს სემესტრი
            $scope.studentSemester = $scope.student.info.semester;
            ProgramService.fetchOne($scope.student.program).then(function (program) {
                $scope.semesters = ['სემესტრი', 'სემესტრის გარეშე'].concat(_.range(1, program.semesters + 1));
            });
        });

        loadPage();

        $scope.selectSubject = function (subject) {
            // before loading
            subject.loading = true;
            //after loading
            subject.loading = false;
            // return;
            $scope.saveDisabled = true;
            $scope.selectedSubject = subject;
            $scope.selectedSeminar = null;
            $scope.selectedLecture = null;
            if (!$scope.selectionCollapse[subject._id]) {
                for (var i in $scope.selectionCollapse) {
                    $scope.selectionCollapse[i] = false;
                }
            }
            $scope.selectionCollapse[subject._id] = !$scope.selectionCollapse[subject._id];
        };

        $scope.toggleSeminar = function (seminar) {
            console.log('toggle seminar', seminar);
            if ($scope.selectedSeminar) {
                $scope.selectedSeminar = null;
                $scope.saveDisabled = true;
                return;
            }
            if (seminar.maxStudents - seminar.selectedCount > 0) {
                $scope.selectedSeminar = seminar;
                if ($scope.selectedLecture || !$scope.selectedSubject.sessionGroups.lectures.length) $scope.saveDisabled = false;
            }
        };

        $scope.toggleLecture = function (lecture) {
            if ($scope.selectedLecture) {
                $scope.selectedLecture = null;
                $scope.saveDisabled = true;
                return;
            }
            if (lecture.maxStudents - lecture.selectedCount > 0) {
                $scope.selectedLecture = lecture;
                if ($scope.selectedSeminar || !$scope.selectedSubject.sessionGroups.seminars.length) $scope.saveDisabled = false;
            }
        };

        $scope.getInfo = function (state) {
            if (state.studentState === 'important') return 'საგანი, პროგრამის მიხედვით, გასავლელია მიმდინარე სემესტრში';
            if (state.studentState === 'critical') return 'საგანი, პროგრამის მიხედვით, გასავლელი იყო წინა სემესტრებში';
            if (state.studentState === 'blocked') return 'საგანი დაბლოკილია წინაპირობის გამო ან კრედიტების რაოდენობა არ არის საკმარისი';
            if (state.studentState === 'normal') return 'საგნის არჩევა შესაძლებელია';
        };

        $scope.getPopover = function (subject) {
            var state = subject.studentState;
            if (state === 'blocked' && !subject.blockers) {
                return 'კრედიტების რაოდენობა არ არის გავლილი ' + subject.preCredits;
            }
            if (state === 'blocked' && subject.blockers) {
                var message = 'დაბლოკილია, წინაპირობების გამო:\n';
                for (var i in subject.blockers) {
                    var blocker = subject.blockers[i];
                    message += '"' + blocker.name + '" - ' + blocker.subject.code + '\n';
                }
                return message;
            }
        };

        $scope.subjectComparator = function (v1, v2) {


            // If we don't get strings, just compare by index
            if (v1.type !== 'string' || v2.type !== 'string') {
                return (v1.index < v2.index) ? -1 : 1;
            }

            return ($scope.subjectStates[v1.value] > $scope.subjectStates[v2.value]) ? -1 : 1;
        };

        function filterSubjects() {
            if (!$scope.subjects) return;
            $scope.selectedSubjects = [];
            $scope.passedSubjects = [];
            $scope.filtered = [];
            $scope.subjects.forEach(function (subject) {
                if (subject.studentState === 'current') $scope.selectedSubjects.push(subject);
                else if (subject.studentState === 'passed') $scope.passedSubjects.push(subject);
                else $scope.filtered.push(subject);
            });

            $scope.allCredits = _.sumBy($scope.passedSubjects, 'credits');

            if ($scope.subNameOrCode) {
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return subject.name.indexOf($scope.subNameOrCode) !== -1
                        || subject.subject.code.indexOf($scope.subNameOrCode) !== -1
                });
            }
            if ($scope.semester !== 'სემესტრი') {
                var check = $scope.semester === 'სემესტრის გარეშე' ? null : $scope.semester;
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return check ? subject.semester === parseInt(check) : !subject.semester;
                });
            }
            if ($scope.subjectType) {
                var check = $scope.subjectType;
                $scope.filtered = $scope.filtered.filter(function (subject) {
                    return check ? subject.type === check : !subject.type;
                });
            }

            $scope.groupedSelections = _.groupBy($scope.filtered, 'type');
            $scope.types = Object.keys($scope.groupedSelections);
            // Object.values($scope.groupedSelections).forEach(function (subjects) {
            //     console.log(subjects)
            //     var a = subjects.sort(subjectComparator)
            //     console.log(a)
            // })
        }

        function loadPage(page, cb) {
            cb = cb || function () {
            };

            Students.selectionList().then(function (data) {
                $scope.subjects = data;

                _.each(data, function (subject) {
                    $scope.selectionCollapse[subject._id] = false;
                });

                $scope.allCredits = _(data)
                    .filter(function (subject) {
                        return subject.studentState === 'passed'
                    })
                    .sumBy(function (subject) {
                        return subject.credits;
                    });


                getFreeCredits();
                filterSubjects();
            });
        }

        var getFreeCredits = function () {
            if ($scope.studentSemester % 2) $scope.freeCredits = 40;
            // else 75 - lastSemesterCredits

            $scope.freeCredits = 40;

            $scope.currentCredits = _($scope.subjects)
                .filter(function (subject) {
                    return subject.studentState === 'current'
                })
                .sumBy(function (subject) {
                    return subject.credits;
                });

            $scope.freeCredits -= $scope.currentCredits;
        };

        $scope.applyFilter = function () {
            var semester;

            if ($scope.semester === 'სემესტრი') {
            } else if ($scope.semester === 'სემესტრის გარეშე') {
                semester = null;
                $scope.semesterSubjects = {null: $scope.semesterSubjects[semester]};
            }
            else {
                semester = $scope.semester;
                $scope.semesterSubjects = {semester: $scope.semesterSubjects[semester]};
            }

            $scope.keys = _.keys($scope.semesterSubjects);
        };

        $scope.selectionSubjectClasses = function (subject) {
            var selectionSubjectClass = '';
            if ($scope.selectionCollapse[subject._id]) selectionSubjectClass += ' active ';
            if (subject.subjectActivation) {
                if (subject.studentState === 'normal') selectionSubjectClass += ' normal-subject ';
                else if (subject.studentState === 'critical') selectionSubjectClass += ' critical-subject ';
                else if (subject.studentState === 'important') selectionSubjectClass += ' important-subject ';
                else if (subject.studentState === 'blocked') selectionSubjectClass += ' blocked-subject ';
            } else {
                selectionSubjectClass += ' blocked-subject ';
            }

            return selectionSubjectClass;
        };

        $scope.selectedSubjectClass = function (subject) {
            if (subject.studentSubject.selectionState === 'proved') return ' proved-selected-subject ';
            else if (subject.studentSubject.selectionState === 'processing') return ' pending-selected-subject ';
            else if (subject.studentSubject.selectionState === 'not_proved') return ' not-proved-selected-subject ';
            return ' ';
        };

        $scope.subjectStateClass = function (subject) {
            var stateClass;
            if (subject.studentState === 'passed') stateClass = 'passed-subject';
            if (subject.studentState === 'current') stateClass = 'current-subject';
            if (subject.studentState === 'failed') stateClass = 'failed-subject';
            return stateClass;
        };

        $scope.showSelectionButton = function (subject) {
            var notShowOn = ['passed', 'blocked', 'current'];
            return $scope.freeCredits > 0 && $scope.freeCredits >= subject.credits && subject.subjectActivation && !_.includes(notShowOn, subject.studentState);
        };

        $scope.notActiveSubject = function (subject) {
            var notShowOn = ['passed', 'blocked', 'current'];
            return !subject.subjectActivation && !_.includes(notShowOn, subject.studentState);
        };

        $scope.save = function () {
            var subject = $scope.selectedSubject;
            Students.chooseSelection(subject.subjectActivation._id, $scope.selectedLecture._id, $scope.selectedSeminar._id).then(function (resp) {
                $scope.selectionCollapse[subject._id] = !$scope.selectionCollapse[subject._id];
                subject.studentState = 'current';
                subject.studentSubject = resp;
                _.remove($scope.filtered, {_id: subject._id});
                $scope.selectedSubjects.push(subject);
                $scope.subNameOrCode = null;
            })
        };
    }
]);
